import * as React from 'react';
import { DesignTokenSizeEnum, styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
export { DesignTokenSizeEnum as ListGutter };
const StyledList = styled.ul.withConfig({ displayName: "StyledList", componentId: "sc-1v05jo" }) `list-style-type:none;padding:0;margin:0;display:grid;row-gap:${({ theme, gutter }) => theme.size[gutter || 'static300']};`;
export const List = (props) => {
    const { children, gutter, isOrdered = false, appearance } = props;
    const commonProps = getCommonProps(props);
    const childrenArr = React.Children.toArray(children);
    const markerSize = Math.floor(Math.pow(childrenArr.length, 1 / 10));
    const childrenElements = childrenArr.map((child) => React.cloneElement(child, {
        appearance,
        markerSize,
    }));
    return (React.createElement(StyledList, Object.assign({ as: isOrdered ? 'ol' : 'ul', gutter: gutter }, commonProps), childrenElements));
};
